export const css = {
    root: '_3ErGoEgR',
    input: 'Zvi8jDxO',
    toggleMenuButton: '_3gJog24g',
    popup: '_1ZosA1MW',
    ' _key': 'certwise-theme/dojo/time-picker'
};
export default css;
